'use strict';
import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	Typography,
	Box,
	IconButton
} from '@mui/material';
import { Close, OpenInNew } from '@mui/icons-material';
import { Brand } from '@/lenses/uilenses/theme/colors';

const LinkRow = ({ label, url, onClose }) => (
	<ListItem disablePadding>
		<ListItemButton
			component="a"
			href={url}
			target="_blank"
			rel="noopener noreferrer"
			onClick={() => onClose()}
			sx={{
				borderRadius: 2,
				mb: 1,
				'&:hover': {
					background: Brand.metaboliteWhite
				}
			}}
		>
			<ListItemText
				primary={
					<Typography variant="subtitle1" sx={{ fontWeight: 600, color: Brand.darkModeBlue }}>
						{label}
					</Typography>
				}
				secondary={
					<Typography variant="body2" sx={{ color: Brand.molecularBlue, wordBreak: 'break-all' }}>
						{url}
					</Typography>
				}
			/>
			<OpenInNew sx={{ color: Brand.molecularBlue, ml: 1 }} fontSize="small" />
		</ListItemButton>
	</ListItem>
);

export const LearningCenterLinksModal = ({ open, onClose, links = [] }) => {
	const hasLinks = links.length > 0;

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="sm"
			fullWidth
			PaperProps={{
				sx: {
					borderRadius: 3,
					border: `1px solid ${Brand.precisionGrey}`
				}
			}}
		>
			<DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
				<Typography variant="h6" component="span" sx={{ fontWeight: 700, color: Brand.darkModeBlue }}>
					Learning Center
				</Typography>
				<IconButton onClick={onClose} aria-label="close" size="small">
					<Close />
				</IconButton>
			</DialogTitle>
			<DialogContent dividers>
				{hasLinks ? (
					<List sx={{ pt: 0 }}>
						{links.map((item) => (
							<LinkRow key={item.branchId || item.url} label={item.label} url={item.url} onClose={onClose} />
						))}
					</List>
				) : (
					<Box sx={{ py: 2 }}>
						<Typography variant="body2" sx={{ color: Brand.molecularBlue }}>
							No learning resources are linked to your account yet. If you recently gained access, try signing out
							and back in. Otherwise contact your Metabolon representative.
						</Typography>
					</Box>
				)}
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button onClick={onClose} variant="contained" sx={{ textTransform: 'none', borderRadius: 2 }}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default LearningCenterLinksModal;
